import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
declare var $: any;
declare var XLSX: any;
@Component({
  selector: 'app-member-import',
  templateUrl: './member-import.component.html',
  styleUrls: ['./member-import.component.scss']
})
export class MemberImportComponent implements OnInit {
  obj_data: any;
  file_name: any;
  constructor(
    private util: UtilService,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    let that = this;
    $("#btnFile").change(function (e: any) {
      that.file_name = e.target.files[0].name;
      that.ConfirmUpload(this);
    });
  }

  async ConfirmUpload(input: any) {
    let that = this;
    if (input.files && input.files[0]) {
      var ext = $("#btnFile").val();
      var res = ext.split('.');
      console.log(res);
      if (res[1] == 'xls' || res[1] == 'xlsx') {
        await this.PreUpload();
        $('#lblData').html('Import data' + that.file_name);
        $('#dlgConfirm').modal();
      } else {
        that.util.ErrorDialog('File Not Support!');
      }
    }
  }
  PreUpload() {
    let that = this;
    var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
    if (regex.test($("#btnFile").val().toLowerCase())) {
      if (typeof (FileReader) != "undefined") {
        var reader = new FileReader();

        //For Browsers other than IE.
        if (reader.readAsBinaryString) {
          reader.onload = function (e: any) {
            that.ProcessExcel(e.target.result);
          };
          reader.readAsBinaryString($("#btnFile")[0].files[0]);
        } else {
          //For IE Browser.
          reader.onload = function (e: any) {
            var data = "";
            var bytes = new Uint8Array(e.target.result);
            for (var i = 0; i < bytes.byteLength; i++) {
              data += String.fromCharCode(bytes[i]);
            }
            that.ProcessExcel(data);
          };
          reader.readAsArrayBuffer($("#btnFile")[0].files[0]);
        }
      } else {
        alert("This browser does not support HTML5.");
      }
    } else {
      alert("Please upload a valid Excel file.");
    }
  }

  ProcessExcel(data: any) {
    //Read the Excel File data.
    var workbook = XLSX.read(data, {
      type: 'binary'
    });

    //Fetch the name of First Sheet.
    var firstSheet = workbook.SheetNames[0];

    //Read all rows from First Sheet into an JSON array.
    var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);

    console.log(excelRows);


    this.obj_data = excelRows;

    // $('#tblData').DataTable();
  }
  Upload() {
    if (this.obj_data != null) {
      if (this.obj_data.length > 0) {
        this.apiService.post('member', 'importdata', this.obj_data);
        this.util.SuccessDialog('Success Please Search For Re-Check Your Data');
      } else {
        this.util.ErrorDialog('Please select data file');
      }
    } else {
      this.util.ErrorDialog('Please select data file');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/member/member-import/member-import.component.ts